import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading, impersonating } = useAuth();
  const location = useLocation();

  // Splash only when initial auth load is still pending
  // AND no impersonation swap is in flight. VIEW AS token
  // swaps must NEVER render the app-splash.
  // ceo_instruction_ref:
  //   impersonation_no_loading_flash_31may2026
  if (loading && !impersonating) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FCFBF9]" data-testid="auth-loading">
        <div className="text-center">
          <img src="https://customer-assets.emergentagent.com/job_distribution-pro-1/artifacts/44tlre5m_IMG_2568.png" alt="Revitalise Keratin" className="w-40 mx-auto mb-4" />
          <div className="text-sm text-muted-foreground">Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    // ceo_instruction_ref: notification_deeplink_receiving_end_16aug2026
    // Carry the full original path (with parameters) into login so the
    // record opens after sign-in instead of the generic dashboard.
    const target = `${location.pathname}${location.search}`;
    const suffix = target && target !== '/' ? `?redirect=${encodeURIComponent(target)}` : '';
    return <Navigate to={`/login${suffix}`} state={{ from: location }} replace />;
  }

  return children;
}
